import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useKotContext } from '../context/kotContext';
import { buildKotPrintDocument, printKotDocuments, splitKotItems } from './kotPrintUtils';
//import { useKotContext } from '../context/kotContext';

const UseKotPrint = (arr1, tableNo, totalAmount, generateKotNo, nc,) => {

  const { updateKotNo, fetchServerName, serverName } = useKotContext();
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [kotBill, setKotBill] = useState([]);
  const requestInFlight = useRef(false);
  const idempotencyKey = useRef(
    window.crypto?.randomUUID?.() ||
      `kot-${Date.now()}-${Math.random().toString(36).slice(2)}`
  );
  console.log(nc, 'kotBill.nc4')



  //console.log(generatekotNo,'generateKotNo')
  const [kotData, setKotData] = useState({
    foodItem: arr1 || [],
    tableNo: tableNo || '',
    kotNo: '',
    totalBilling: totalAmount || 0,
    serverName: serverName,
    nc: nc || false,
  });
  //console.log(kotData,'kotData.nc1')

  const customerId = localStorage.getItem('customerId');


  const getFormattedCurrentDate = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}${period.toLowerCase()}`;
    return [formattedDate, `${day}-${month}-${year}`, `${hours}:${minutes} ${period}`];
  };

  useEffect(() => {
    fetchServerName(customerId, tableNo);
    const [_, formattedDate, formattedTime] = getFormattedCurrentDate();
    setDate(formattedDate);
    setTime(formattedTime);
  }, [customerId, tableNo]);
  useEffect(() => {
    setKotData((prev) => ({
      ...prev,
      serverName: serverName,  // this gets updated from context
    }));
  }, [serverName]);
  const kotPrint = async () => {
    if (requestInFlight.current) return;
    requestInFlight.current = true;
    try {
      // const randomKotNumber = `${tableNo}-${Math.floor(Math.random() * 10000)}`;

      // Update KOT data
      const updatedKotData = {
        ...kotData,
        foodItem: arr1,
        tableNo,
        kotNo: generateKotNo,
        totalBilling: totalAmount,
        nc: nc, // Ensure nc is passed here correctly
        serverName: serverName,
        idempotencyKey: idempotencyKey.current,
      };
      console.log(updatedKotData, 'updatedKotData')
      //setKotData(updatedKotData);

      updateKotNo(customerId, generateKotNo, tableNo);

      // POST to backend
      const response = await axios.post('https://api.rcb.tdrsoftware.in/api/kotBillRegister', {
        customerId,
        data: updatedKotData
      });

      toast.success(response.data.message);
      idempotencyKey.current =
        window.crypto?.randomUUID?.() ||
        `kot-${Date.now()}-${Math.random().toString(36).slice(2)}`;


      // Store one combined KOT above; only its printed slips are separated.
      const { foodItems, barItems } = splitKotItems(updatedKotData.foodItem);
      const documents = [
        ['Food KOT', foodItems],
        ['Beer / Bar KOT', barItems],
      ].filter(([, items]) => items.length > 0).map(([title, items]) => buildKotPrintDocument({
        title, items, tableNo: updatedKotData.tableNo, kotNo: updatedKotData.kotNo,
        serverName: updatedKotData.serverName, date, time,
      }));
      await printKotDocuments(documents);

      //setTimeout(() => window.location.reload(), 2000);
    } catch (error) {
      console.error('Error saving KOT:', error);
      toast.error('Error in KOT');
    } finally {
      requestInFlight.current = false;
    }
  };

  return kotPrint;
};

export default UseKotPrint;
